"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBangsHeightState = void 0;
var tslib_1 = require("tslib");
var React = (0, tslib_1.__importStar)(require("react"));
var useJSBridgeInstance_1 = require("./useJSBridgeInstance");
/**
 * 顶部 "刘海"\"挖孔" 屏幕占用的高度。
 * @returns
 */
function useBangsHeightState() {
    var _this = this;
    var jsBridge = (0, useJSBridgeInstance_1.useJSBridgeInstance)();
    var _a = React.useState(0), height = _a[0], setHeight = _a[1];
    React.useEffect(function () {
        var func = function () { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
            var bangsHeight;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, jsBridge.getBangsHeight()];
                    case 1:
                        bangsHeight = (_a.sent())[0];
                        if (!bangsHeight) {
                            return [2 /*return*/];
                        }
                        setHeight(Number(bangsHeight));
                        return [2 /*return*/];
                }
            });
        }); };
        func();
    }, [jsBridge]);
    return height;
}
exports.useBangsHeightState = useBangsHeightState;
//# sourceMappingURL=useBangsHeightState.js.map